const accessDashboard = {

    DASHBOARD: { name: 'Dashboard', path: '/dashboard' },

    DASHBOARDSECOND: { name: 'Dashboard', path: '/' }

}

export default accessDashboard;